import { render } from "./StudentFinalTranscriptViewer.vue?vue&type=template&id=2fd0c969"
import script from "./StudentFinalTranscriptViewer.vue?vue&type=script&lang=js"
export * from "./StudentFinalTranscriptViewer.vue?vue&type=script&lang=js"

import "./StudentFinalTranscriptViewer.vue?vue&type=style&index=0&id=2fd0c969&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__